export type IconSize = 'small' | 'large';

export enum IconSizeEnum {
    small = 30,
    large = 100,
}
